export const FirebaseConfig = {
  apiKey: "AIzaSyCLHY0uSlK8vXsJGtc0FGl6vcTjyIPHsF8",
  authDomain: "myportfolio-7b547.firebaseapp.com",
  databaseURL: "https://myportfolio-7b547.firebaseio.com",
  projectId: "myportfolio-7b547",
  storageBucket: "myportfolio-7b547.appspot.com",
  messagingSenderId: "888427172097"
}